import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/casas-de-empenio/';

/**
 * GET CasaDeEmpenios
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCasasDeEmpenio = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Casa De Empenio
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getCasaDeEmpenio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Casa De Empenio
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postCasaDeEmpenio = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Casa De Empenio
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchCasaDeEmpenio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Casa De Empenio
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteCasaDeEmpenio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Casa De Empenio
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosCasaDeEmpenio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Casas de Empeño para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCasasDeEmpenioCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/casa-de-impenio-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
